export default __webpack_public_path__ + "static/SR France - Nanotechnologie - Note d'information-38631baa7e23b2d862bf514a7b0a50bc.pdf";